import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedItemId } from '../redux/selectors/selectionSelectors';
import { clearInternalActiveEditor } from 'tinymce-plugins/hscopilotcollaboration/activeEditorAtom';
export default function useClearCopilotActiveEditorOnModuleChange() {
  const selectedItemId = useSelector(getSelectedItemId);
  useEffect(() => {
    clearInternalActiveEditor();
  }, [selectedItemId]);
}